import { render, staticRenderFns } from "./PartialDescription.vue?vue&type=template&id=13e70536&scoped=true&lang=html"
import script from "./PartialDescription.vue?vue&type=script&lang=js"
export * from "./PartialDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e70536",
  null
  
)

export default component.exports